import {Fragment, useEffect, useState} from "react";
import WelcomeToSession from "../Home/components/WelcomeToSession";
import OurServiceAPI from  '~/api/ourServiceApi';
import AOS from "aos";
import Skeleton from "react-loading-skeleton";
import "aos/dist/aos.css";
function OurService(){
    const [ourService, setOurService] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        OurServiceAPI.getAll()
            .then((res) => {
                setOurService(res.data);
                setLoading(false);
            })
            .catch((err) => {
                ;
            });
        AOS.init({
            duration: 1000,
            easing: "ease-in-out",
            once: true,
            mirror: false
        });
    }, []);
    return (
        <Fragment>
            <WelcomeToSession screen="Our Service"/>
            <section>
                <div className="container-medium">
                    {
                        loading && (
                            <div>
                                <Skeleton height={10} count={5} containerClassName={"w-100"}/>
                            </div>
                        )
                    }
                    {
                        !loading && (
                            <div className="row gy-7">
                                {
                                    ourService.map((item, index) => (
                                        <div key={index} className="col-lg-4 col-md-6 service-item d-flex aos-init aos-animate" data-aos="fade-up" data-aos-delay={(index + 1)*100}>
                                            <div className="icon flex-shrink-0 me-5 fs-5 text-danger"
                                                 dangerouslySetInnerHTML={{__html: item.Icon}}/>
                                            <div>
                                                <h4 className="text-primary">{item.Title}</h4>
                                                <p className="fs-8-1">{item.Description}</p>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        )
                    }
                </div>
            </section>
        </Fragment>
    )
}

export default OurService;
